import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import PlasmicHost from "./components/PlasmicHost";
import { DesktopStateProvider } from "./components/DesktopStateProvider";
import CustomComponentTestPage from "./components/CustomComponentTestPage";
import {
  TestPageOne,
  TestPageTwo,
  TestPageThree,
  TestPageFour,
} from "./components/TestPages";
import WebCommunityHome from "./components/WebCommunityHome";
import WebCommunityForum from "./components/WebCommunityForum";
import ButonulCareDeschideOFereastraTest from "./components/ButonulCareDeschideOFereastraTest";
import PersistentDesktop from "./components/PersistentDesktop";
import TestPageTestAppWindow from "./components/TestPageTestAppWindow";
import Op1WebDesktopLayer from "./components/Op1WebDesktopLayer";
import DesktopLayerLayout from "./components/DesktopLayerLayout";
import Op1WebHomepage from "./components/Op1WebHomepage";
import Op1WebForum from "./components/Op1WebForum";

// Placeholder home route. Once you run `npx plasmic sync`, swap this out
// for the generated page component (e.g. WebHomepage from
// src/components/WebHomepage.jsx), the same way main/src/App.js does it.
function Home() {
  return (
    <div style={{ padding: 40, fontFamily: "sans-serif" }}>
      <h1>one platform</h1>
      <p>
        Run <code>npx plasmic sync</code> after connecting this project in
        Plasmic Studio, then wire up the generated page component here.
      </p>
      <p>
        Desktop persistence test pages:{" "}
        <Link to="/test-1">Test 1</Link>,{" "}
        <Link to="/test-2">Test 2</Link>,{" "}
        <Link to="/test-3">Test 3</Link>,{" "}
        <Link to="/test-4">Test 4</Link>
      </p>
      <p>
        Real pages:{" "}
        <Link to="/community">Community Home</Link>,{" "}
        <Link to="/community/home">Community Home (/community/home)</Link>,{" "}
        <Link to="/community/forum">Community Forum</Link>,{" "}
        <Link to="/text-trigger-test">Text Trigger Test</Link>
      </p>
    </div>
  );
}

function App() {
  // DesktopStateProvider here stands in for the Website Shell System's
  // future job of mounting the Desktop once around the persistent app -
  // it keeps Desktop/window state alive independent of whatever page is
  // in the Background Space. Once Members/Forum pages are wired up as
  // real routes, the Desktop Plasmic component gets mounted inside this
  // same provider, alongside (not inside) the routed background page.
  return (
    <DesktopStateProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* Plasmic Studio app host: lets Studio discover code components */}
          <Route path="/plasmic-host" element={<PlasmicHost />} />
          <Route
            path="/custom-component-test-page"
            element={<CustomComponentTestPage />}
          />
          {/* Scrappy test-only routes (see TestPages.jsx) - four distinct
              pages that all render the same live Desktop, so we can click
              between them and confirm window/dock state (held in
              DesktopStateProvider above this Router) survives client-side
              navigation instead of resetting. */}
          <Route path="/test-1" element={<TestPageOne />} />
          <Route path="/test-2" element={<TestPageTwo />} />
          <Route path="/test-3" element={<TestPageThree />} />
          <Route path="/test-4" element={<TestPageFour />} />
          {/* Real Plasmic-designed pages, selected from the project for the
              next round of persistence testing. PersistentDesktop overlays
              the same dock/windows on top of each (click-through except
              for its own dock/window chrome - see
              WindowManagerSurface.module.css), so a window opened on a
              test page stays open and VISIBLE here too, not just
              persisted invisibly in state. */}
          {/* Build review NOV.01.2026: OP1Web background pages under the
              OP1Web desktop layer (windows + dock). The layout route keeps
              the desktop mounted while OP1WebBgSpaceButton switches the
              background page. */}
          <Route element={<DesktopLayerLayout />}>
            <Route path="/community" element={<Op1WebHomepage />} />
            <Route path="/community/forum" element={<Op1WebForum />} />
          </Route>
          {/* Previous community setup (old pages + old desktop), kept. */}
          <Route
            path="/community/home"
            element={
              <>
                <PersistentDesktop />
                <WebCommunityHome />
              </>
            }
          />
          <Route
            path="/community/forum-old"
            element={
              <>
                <PersistentDesktop />
                <WebCommunityForum />
              </>
            }
          />
          {/* New page: has its own plain-text trigger (not the dock) that
              opens the textTest window via the same shared Desktop state.
              PersistentDesktop is still overlaid here so any window already
              open elsewhere (Conversations, Notes, textTest) stays visible
              when you land on this page too. */}
          <Route
            path="/text-trigger-test"
            element={
              <>
                <PersistentDesktop />
                <ButonulCareDeschideOFereastraTest />
              </>
            }
          />
          {/* Page "page test AppWindow": ButtonPrimary with windowId.
              Has its own surface + windows, so no PersistentDesktop. */}
          <Route path="/page-test-AppWindow" element={<TestPageTestAppWindow />} />
          {/* dev/desktop-layer: OP1WebAW / OP1WebAWButton workspace */}
          <Route path="/dev/desktop-layer" element={<Op1WebDesktopLayer />} />
          <Route path="/OP1Web-desktop-layer" element={<Op1WebDesktopLayer />} />
        </Routes>
      </Router>
    </DesktopStateProvider>
  );
}

export default App;
